import DgCard from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgCard.install = function (Vue) {
  Vue.component(DgCard.name, DgCard)
}
export default DgCard

export { DgCard }